import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Container,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import AdomiComponentService from '../../../services/AdomiComponentsService';
import Results from './Results';
import Toolbar from './Toolbar';

import { selector as UserSelector } from '../../../redux/ducks/user';

const useStyles = makeStyles((theme) => ({
  categoryTitle: {
    display: 'inline-block',
    marginRight: '1rem'
  },
  titleEditable: {
    fontSize: '2.18rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 500,
    lineHeight: 1.167,
    letterSpacing: '-0.24px',
    color: '#888',
    marginBottom: '.5rem',
  },
  saveIcon: {
    color: 'white',
  },
  editButton: {
    cursor: 'pointer'
  },
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const AdomiComponentView = () => {
  const classes = useStyles();
  const { user } = useSelector(UserSelector);
  const [adomiComponent, setAdomiComponent] = useState([]);

  const getAdomiComponents = async () => {
    const response = await AdomiComponentService.getAll();

    if (response?.code === 200 && response?.data?.length > 0) {
      setAdomiComponent(response?.data);
    }
  };

  const refresh = async () => {
    if (user?.id) {
      await getAdomiComponents();
    }
  };

  useEffect(() => {
    if (user?.id) {
      getAdomiComponents();
    }
  }, [user]);

  return (
    <Page
      className={classes.root}
      title="Componentes de Adomi"
    >
      <Container maxWidth={false}>
        <Toolbar refresh={refresh} />
        <Box mt={3}>
          <Results data={adomiComponent} onRefresh={refresh} />
        </Box>
      </Container>
    </Page>
  );
};

export default AdomiComponentView;
